import { Injectable, Type } from "@angular/core";
import { PromiseBlotterLookupService } from "../../impl/PromiseBlotterLookupService";
import { IOrderDataPromiseLookupService } from "../IOrderDataPromiseLookupService";
import { IBasePrimeDependent } from "../../IBasePrimeDependent";
import { Subject } from "rxjs";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export { ACTIVE_ORDER_STATES } from "../../../../auth-services";
export { OrderDataModelUpdateSource } from "../../../model/orders/OrderDataModelUpdateSource";

import { LoggerService } from "@bfx/logger";
import { IOrderMigrationEvent } from "shared/cubiq-services/model/core/IOrderMigrationEvent";
const logger = LoggerService.for(__dirname);

export abstract class OrderDataPromiseLookupService
  extends PromiseBlotterLookupService<string, CubiqTS.OrderDataImpl>
  implements IOrderDataPromiseLookupService
{
  constructor() {
    super();
  }
  abstract getModelOrderMigrationSubject(): Subject<IOrderMigrationEvent>;

  abstract subscribeForMarketBar(pairNames: Array<string>): Promise<Array<any>>;
  abstract getOrderData(id: string): Promise<CubiqTS.OrderDataImpl>;
  abstract getOrderReference(id: string): Promise<string>;
  abstract getModifyPreInitDataForOrderId(id: string): Promise<any>;
  abstract getOrderDataForIds(ids: Array<string>): Promise<Array<CubiqTS.OrderDataImpl>>;
  abstract hasOrdersForRateKey(subscriptionKey: string): Promise<boolean>;
  abstract addOrderEntryReference(ref: string): Promise<boolean>;
  abstract removeOrderEntryReference(ref: string): Promise<boolean>;
  abstract hasOrderEntryReference(ref: string): Promise<boolean>;
  abstract getModelDetailFillSubject(): Subject<any>;
  abstract setDetailFillIds(ids: Array<[string, string]>): void;
  abstract getAllOrderDatas(): Promise<Array<CubiqTS.OrderDataImpl>>;
  abstract getTransferUpdateSubject(): Subject<any>;
}
